import NoticeBoard from './NoticeBoard';

export default NoticeBoard;
